import React from "react";
import Axios from "axios";
import Moment from "react-moment";
import logo from "../../ISQ-Logo.jpg";
import "moment/locale/pt";
import moment from "moment";

import Popup from "../Popup";

import i18n from '../../i18n';
import validator from 'validator';
import { useTranslation } from 'react-i18next'


  
	const changeLanguage = (event) => {
		

		
	  console.log(event.target.value);
	  i18n.changeLanguage(event.target.value);

	  
	}

function Translate({value}) {
	const { t} = useTranslation();

	
	
	return  t(value) 
  }
class IncentivarFaturaEletronicaTodos extends React.Component {
  constructor() {
    super();
    this.state = {
      data: -1,
      loading: true,
      succeeded: -2 ,
      nif : "" ,
      fullName : "" ,
      succeeded : null , 
      emailFaturaEletronica : "" ,
      popupShow: false,
			popupTitle: "",
      popupLines: [],
      approvedTime : null,
      disabledButton : false , 

    };
    this.approveFatEle = this.approveFatEle.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.changePopupStatus = this.changePopupStatus.bind(this);
  }

  handleChange(event) {
    const inputName = event.target.name;
    
    console.log([inputName]);
    console.log( event.target.value);
    this.setState({
		
			[inputName]: event.target.value})

  }

  async approveFatEle() {

    if (!validator.isEmail(this.state.emailFaturaEletronica)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" , 
				popupLines: ["Email Inválido"],
			
			  });

			return 
		  
		
		}
    this.setState({ loading: true });
    this.setState({ disabledButton: true });
    await Axios.post(



      `https://${process.env.REACT_APP_API_IP}/api/clientesparaincentivarfaturaeletronica/approve/`,
      { id: this.props.match.params.tokenId ,
        EmailFaturaEletronica: this.state.emailFaturaEletronica }
    )
      .then(response => {

        console.log(response);
        
        if (response.status === 200){
          this.setState({ aprovado: 1, loading: false });

          this.setState({ disabledButton: false });
        }
      })
      .catch(error => {
        console.log(error.response);
        this.setState({ disabledButton: false });
        this.setState({ aprovado: -1, loading: false  ,
        
        popupShow : true , 
      
      	popupTitle: "Error" , 
				popupLines: ["Ocorreu um erro de integração, por favor entre em contacto com o serviço ao cliente servico.clientes@isq.pt"] });
      });
  }

  changePopupStatus() {
    console.log("change status");
      this.setState({
        popupShow: !this.state.popupShow,
        viesModalState: false
      });
    }

  async fetchData(token) {
    await Axios.get(
      `https://${process.env.REACT_APP_API_IP}/api/clientesparaincentivarfaturaeletronica/getclient/${this.props.match.params.tokenId}`
    )
      .then(response => {
        console.log(response);
        if (response.status === 200) {
         
         
           
            this.setState({ 
              
              data: 1 , 
              nif : response.data.nif , 
              succeeded : response.data.succeeded , 
              fullName : response.data.fullName , 
              emailFaturaEletronica : response.data.emailFaturaEletronica == undefined ?  "" : response.data.emailFaturaEletronica ,
              approvedTime : response.data.approvedTime
            
               });
         
        } else {
          console.log("Resposta válida:");
          console.log(response);
        }
      })
      .catch(error => {
        console.log("Erro:");
        console.log(error.response);
        this.setState({ data: -1, loading: false });
      });
  }

  componentDidMount() {
    this.fetchData(this.props.match.params.tokenId);
    moment.locale("pt");
  }

  render() {

    
    const { data, loading, aprovado } = this.state;

    if (aprovado === 1) {
      return (
        <>
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
          
                  <br></br><br></br>
              <div className="main-card mb-3 card">
                <div className="card-body">
                  <h4>Faturação eletrónica aceite com sucesso</h4>
                  <br />
                  <h5>Obrigado</h5>
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>{" "}
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );
    }
    if (this.state.succeeded) {
      return (
        <>
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
            
                  <br></br><br></br>
              <div className="main-card mb-3 card ">
                <div className="card-title text-center">
                  
                  <br></br>A Fatura Eletrónica já foi aceite com sucesso</div>
                <div className="card-body">
                  <div className="row">
                    
                  <div className="col-sm-4 col-form-label"><b>Nome: </b>  </div>
                    <div className="col-sm-8 col-form-label">{this.state.fullName}
                       </div>

                       <div className="col-sm-4 col-form-label"><b>Nif:  </b> </div>
                    <div className="col-sm-8 col-form-label">{this.state.nif}
                       </div>

                       <div className="col-sm-4 col-form-label"><b>Fatura Eletrónica: </b>  </div>
                    <div className="col-sm-8 col-form-label">{this.state.emailFaturaEletronica}
                       </div>


                       <div className="col-sm-4 col-form-label"><b>Aceite a: </b>  </div>
                    <div className="col-sm-8 col-form-label">  <Moment format="DD-MM-YYYY HH:mm[h]">
								{this.state.approvedTime}  
							</Moment> 
                       </div>
                       </div>
                
                
                  
                
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );
    }
    if (data === 1) {
      return (
        <React.Fragment>
					   <Popup
          updateStatus={this.changePopupStatus}
          popupShow={this.state.popupShow}
          popupTitle={this.state.popupTitle}
		  popupLines={this.state.popupLines}
		
        ></Popup>
       
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
          
                  <br></br><br></br>
              <div className="main-card mb-3 card text-center" >
                <div className="card-title">
                <br></br>
                
                    Adira à faturação eletrónica introduzindo o endereço de email

                    
                    
                   
                 
              </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4 col-form-label"><b>Nome:</b>   </div>
                    <div className="col-sm-8 col-form-label">{this.state.fullName}
                       </div>

                       <div className="col-sm-4 col-form-label"><b>Nif:  </b> </div>
                    <div className="col-sm-8 col-form-label">{this.state.nif}
                       </div>

                        <br></br>
                        <br></br>
                       
                       
                       
                   
                  </div>
                  <h4><b>Fatura Eletrónica: </b> </h4>
                  <br></br>
                  
                  <input
										type="text"
										className="form-control"
										value={this.state.emailFaturaEletronica}
										onChange={this.handleChange}
										name="emailFaturaEletronica"
										maxLength="50"
									/>
                 
                </div>
               
              <div className="row">
                <div className="col-sm-6">  </div>
              
                  
                 
                <div className="col-sm-12"><button
                    onClick={this.approveFatEle}
                    className="btn btn-primary btn-lg"
                    disabled = {this.state.disabledButton}
                  >
                    Aprovar
                  </button>  </div>

                  </div>
                  <br></br>
                
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>{" "}
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
          </React.Fragment>
      );
    }
  
 else if( !loading) {
      return (
       
        <>
        
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
            <div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
                  <br></br><br></br>
              <div className="main-card mb-3 card">
                <div className="card-body">
                <Translate value = "erroobtercomolinkdeacessofornecido" ></Translate>
                 
                  <br />
                  {this.props.match.params.tokenId}
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>{" "}
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );

      }else {
        
         return ("");
      }
    }
  
}

export default IncentivarFaturaEletronicaTodos;
